module.exports = __webpack_public_path__ + "img/logo-min.43015aed.png";